import AdminPharmaciesContainer from './pharmacies-container';

export default AdminPharmaciesContainer;
